export default "__VITE_ASSET__D$Iq4j_P__"